import React from 'react'

const BookingDetails = () => {
  return (
    <div>booking-details</div>
  )
}

export default BookingDetails